export default __webpack_public_path__ + "static/media/ProfitSKU.16e9705f.svg";